import { render, staticRenderFns } from "./evaluationProject.vue?vue&type=template&id=0f737ff3&scoped=true&"
import script from "./evaluationProject.vue?vue&type=script&lang=js&"
export * from "./evaluationProject.vue?vue&type=script&lang=js&"
import style0 from "./evaluationProject.vue?vue&type=style&index=0&id=0f737ff3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f737ff3",
  null
  
)

export default component.exports